const Features = () => {
  const features = [
    {
      icon: "💎",
      title: "Rundum-Betreuung",
      description: "Von Outfitberatung bis hin zur Content-Produktion – wir sind an deiner Seite."
    },
    {
      icon: "🎯",
      title: "Einzigartige Vorteile",
      description: "Zugang zu Dessous und Toys zu unseren Einkaufspreisen."
    },
    {
      icon: "🚀",
      title: "Professionelle Unterstützung",
      description: "Unser erfahrenes Team steht dir jederzeit mit Rat und Tat zur Seite."
    }
  ];

  return (
    <section className="py-20 lg:py-32 relative overflow-hidden">
      {/* Animated background gradients */}
      <div className="absolute inset-0 bg-deep-black -z-10"></div>
      <div className="absolute -top-1/2 right-0 w-3/4 h-full bg-gradient-to-bl from-hot-pink/20 to-accent-purple/20 blur-3xl animate-float"></div>
      <div className="absolute -bottom-1/2 left-0 w-3/4 h-full bg-gradient-to-tr from-neon-blue/20 to-hot-pink/20 blur-3xl animate-float" style={{ animationDelay: '-3s' }}></div>

      <div className="container-custom px-4">
        <div className="text-center mb-12 lg:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-playfair font-black mb-4 sm:mb-6">
            Unser <span className="text-gradient">Versprechen</span>
          </h2>
          <p className="text-lg sm:text-xl text-white/80 max-w-3xl mx-auto">
            Mit Angel & Devil Network bist du nie allein. Wir sind dein Partner auf dem Weg zum Erfolg.
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 lg:mb-20">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="feature-card group"
            >
              <div className="text-4xl sm:text-5xl mb-4 sm:mb-6 transform group-hover:scale-110 transition-transform duration-300">{feature.icon}</div>
              <h3 className="text-gradient font-playfair text-xl sm:text-2xl mb-3 sm:mb-4">{feature.title}</h3>
              <p className="text-white/80 text-sm sm:text-lg">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
          <div className="relative glass-effect rounded-2xl sm:rounded-3xl p-6 sm:p-8 lg:p-12 text-center">
            <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-6 sm:mb-8 font-light">
              Ob du gerade erst anfängst oder bereits Erfahrung hast – 
              wir geben dir die Werkzeuge, das Wissen und die Unterstützung, 
              um dich in der Branche zu behaupten.
            </p>
            <p className="text-xl sm:text-2xl md:text-3xl font-playfair text-gradient font-bold">
              Lass uns gemeinsam deine Talente entfesseln und deine Versuchung in Erfolg verwandeln!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
